<template>
    <VCard elevation="0" class="timezone-selection">
        <VMenu
            :value="isOpen"
            :close-on-click="true"
            :close-on-content-click="false"
            class="timezone-menu"
            :max-width="600"
            :nudge-bottom="-20"
            offset-y
            @input="emitIsOpen"
        >
            <template #activator="{ on, attrs }">
                <div ref="selectTimezone" v-bind="attrs" class="selected-timezone" v-on="on">
                    <VTextField
                        v-model="formattedTimezoneString"
                        :append-icon="isOpen ? 'mdi-menu-up' : 'mdi-menu-down'"
                        :outlined="true"
                        :class="classList"
                        label="Timezone"
                        :full-width="false"
                        readonly
                        @focus="emitFocus"
                    />
                </div>
            </template>
            <VCard class="timezoneMenu">
                <VCardText class="pb-0">
                    <div class="timezone">
                        <div>
                            <span>-12:00</span>
                            <span class="selected-timezone-value">
                                UTC
                                <span>({{ formattedTimezone }})</span>
                            </span>
                            <span>+12:00</span>
                        </div>
                        <VSlider
                            :value="timezoneSliderIndex"
                            :class="classList"
                            track-color="blue lighten-4"
                            track-fill-color="blue"
                            color="blue"
                            thumb-color="blue"
                            max="24"
                            step="1"
                            tick-size="4"
                            ticks="always"
                            @input="handlerSliderValueChange"
                        />
                    </div>
                </VCardText>
            </VCard>
        </VMenu>
    </VCard>
</template>
<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

export default {
    name: 'SrTimezoneSlider',
    props: {
        value: {
            type: Number,
            required: true,
        },
        isOpen: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            internalValue: this.value,
            timezoneFormatter: new Intl.NumberFormat('en', { signDisplay: 'always' }),
        };
    },
    computed: {
        timezoneSliderIndex() {
            return this.internalValue + 12;
        },
        formattedTimezone() {
            return this.timezoneFormatter.format(this.value);
        },
        formattedTimezoneString() {
            return `UTC ${this.formattedTimezone}`;
        },
        classList() {
            return [USER_INPUT_CLASS];
        },
    },
    methods: {
        handlerSliderValueChange(sliderIndex) {
            const newTimezoneInHours = sliderIndex - 12;
            this.updateTimezone(newTimezoneInHours);
        },
        updateTimezone(timezoneInHours) {
            this.internalValue = timezoneInHours;
            this.$emit('input', timezoneInHours);
        },
        emitIsOpen(value) {
            this.$emit('isOpen', value);
        },
        emitFocus() {
            this.$emit('focus');
        },
    },
};
</script>
